import { FactoryProvider } from '@angular/core';
import { MetadataStore } from 'breeze-client';
import { MetadataStoreFactoryService } from './metadata-store-factory.service';

export const metadataStoreProvider: FactoryProvider = {
  provide: MetadataStore,
  useFactory: (factory: MetadataStoreFactoryService): MetadataStore => factory.create(),
  deps: [MetadataStoreFactoryService]
};
